import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import companyApi from '@/features/dashboard/company/api/companyApi.ts';
import { companyApiQueryKeys } from '@/features/dashboard/company/api/companyApi.queryKeys.ts';
import CompanyTimezoneDto from '@/features/dashboard/company/types/CompanyTimezoneDto.ts';

const useGetCompanyTimezone = () => {
  return useQuery(getCompanyTimezoneQueryOptions());
};

export const getCompanyTimezoneQueryOptions =
  (): UseQueryOptions<CompanyTimezoneDto> => ({
    queryKey: companyApiQueryKeys.companyTimezone(),
    queryFn: () => companyApi.getCompanyTimezone(),
    staleTime: Infinity,
  });

export default useGetCompanyTimezone;
